import React from 'react';
import CheckoutBlock from '../CartList/CheckoutBlock';
import VerticalLinearStepper from './VerticalLinearStepper';
import './VerticalStepper.css';
import { useSelector } from 'react-redux';


const VerticalStepper = () => {
    const { cartData } = useSelector(state => state.cart)
    return (
        <div className="container stepper-block">
            <div className="row">
                <div className="col-md-9 stepper-block-verticalLine">
                    <VerticalLinearStepper cartData={cartData} />
                </div>
                <div className="col-md-3">
                    <CheckoutBlock cartData={cartData} />
                </div>
            </div>
        </div>
    );
};

export default VerticalStepper;